import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class UserService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<User[]> => {
    return this.apiHttp.get<User[]>('users');
  };

  public get = (id: number): Observable<User> => {
    return this.apiHttp.get<User>(`users/${id}`);
  };
}

export interface User {
  id: number;
  userName: string;
  email: string;
  givenName: string;
  surname: string;
  userPrincipalName: string;
  ceMember: boolean;
  isActive: boolean;
  requestMember: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/user.service.ts